import * as classNames from 'classnames';
import { Modal } from 'components/content';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./LeadDisable.css');

// Component
@inject('store')
@observer
export class LeadDisable extends React.Component<IAppOnlyStore, {}> {
  @computed private get leadId(): string {
    const { lead } = this.props.store;

    return lead.openLeadDetails !== null
      ? lead.openLeadDetails.providerId.toString()
      : lead.openLeadId
      ? lead.openLeadId.toString()
      : '';
  }

  @computed private get leadDba(): string {
    const { lead } = this.props.store;

    return lead.openLeadDetails !== null && lead.openLeadDetails.dba
      ? lead.openLeadDetails.dba.trim()
      : '';
  }

  @computed private get leadLegalBusName(): string {
    const { lead } = this.props.store;

    return lead.openLeadDetails !== null && lead.openLeadDetails.legalBusName
      ? lead.openLeadDetails.legalBusName.trim()
      : '';
  }

  @computed private get leadName(): string {
    return this.leadDba && this.leadLegalBusName
      ? this.leadDba + ', ' + this.leadLegalBusName
      : this.leadDba
      ? this.leadDba
      : this.leadLegalBusName
      ? this.leadLegalBusName
      : '';
  }

  @computed private get modalTitle(): string {
    const { lead } = this.props.store;

    let str = 'Disable lead';

    if (this.leadDba) {
      str += ' ' + this.leadDba;
    } else if (this.leadLegalBusName) {
      str += ' ' + this.leadLegalBusName;
    } else {
      str += ' #' + lead.openLeadId;
    }

    return str;
  }

  @computed private get promptTitle(): string {
    let str = 'I understand, disable lead';
    str += this.leadId ? ' #' + this.leadId : '';
    str += this.leadDba ? ', ' + this.leadDba : '';
    str += this.leadLegalBusName ? ', ' + this.leadLegalBusName : '';
    return str;
  }

  public render() {
    const { lead } = this.props.store;

    return (
      <Modal
        show={lead.disableOpenLeadShowModal}
        onModalClose={this.handleModalClose}
        title={this.modalTitle}
      >
        {lead.disableOpenLeadShowModal && (
          <div className={s.container}>
            <h3 className={s.message}>
              Disabling lead is permament and irreversible.
            </h3>

            <div className={s.buttonWrapper}>
              <button
                className={classNames(
                  s.button,
                  'boxButton',
                  'boxButtonImportant'
                )}
                onClick={this.handleDisableLead}
              >
                {this.promptTitle}
              </button>
            </div>

            <SavingIndicator
              className={s.saving}
              align="center"
              labels={{
                saving: 'Disabling lead...',
              }}
              status={
                lead.disablingOpenLeadError
                  ? SavingIndicatorStatus.Error
                  : lead.disablingOpenLead
                  ? SavingIndicatorStatus.Saving
                  : SavingIndicatorStatus.None
              }
            />
          </div>
        )}
      </Modal>
    );
  }

  private handleModalClose = () => {
    this.props.store.lead.closeDisableLeadModal();
  };

  private handleDisableLead = () => {
    this.props.store.lead.disableLead(this.props.store.lead.openLeadId);
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Disable/LeadDisable.tsx